// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { Set } from '../../../../ts/models/Set';
import { ResumeExtractTasksAction } from '../../../../ts/services/ResumeExtractTasksAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { ResumeExtractRefreshAction } from '../../../actions/spaces/ResumeExtractRefreshAction';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleResumeExtractRefreshAction(action: ResumeExtractRefreshAction) {
  try {
    yield call(executeResumeExtractRefresh, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeResumeExtractRefresh(items: IExtractTaskInfo[]) {
  const resumeExtractRefreshService = ServiceLocator.get<ResumeExtractTasksAction>('ResumeExtractTasksAction');
  const context = ServiceLocator.getAngularActionContext();
  return resumeExtractRefreshService.execute(Set.fromIdItemArray(items), context);
}
